import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';

function getFavouriteTag(isFavourite: boolean) {
  return isFavourite ? 'add' : 'remove';
}

export function logFavouriteAction(isFavourite: boolean, source: string, prefix: any): void {
  const e = AMPLITUDE_CONSTANTS.favourites;

  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: source,
    [e.attributes.transaction_category_id]: prefix,
    [e.attributes.action_type]: getFavouriteTag(isFavourite), // opposite since the state is toggled
  });
}
